// extracted by mini-css-extract-plugin
module.exports = {"error":"RegisterError_error__4pHQa"};